var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cd8873e21ce374ad915a9252788282576c15a3dc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yogobe-web@yogobe"]={id:"cd8873e21ce374ad915a9252788282576c15a3dc"};
      